import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../../utility/SweetAlert'
import ApiService from '../../../services/ApiService'

const InteractorReturnHistoryView = () => {
  const { t } = useTranslation()
  const returnHistoryView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest(
        '/transaction-retur-header/check-retur-available',
        payload,
        (response) => {
          if (response.status_code === 200) {
            if (response.data) {
              callback(response.data)
            }
          } else {
            showAlert({
              icon: 'info',
              message: t(`response_message.data_not_exist`),
              timer: 2000,
            })
          }
          loading(false)
        },
      )
    },
    [t],
  )
  return { returnHistoryView }
}

export default InteractorReturnHistoryView
